import {
  SkuInfoType,
  AddressItemType,
  SkuPriceType,
  FreightInfoType,
  ProductDetailType,
  SaleStockInfoType,
  InstallmentPlanItemType,
} from "../types";

import * as constants from "./constants";

export function setCurrentSku(skuInfo: SkuInfoType) {
  return {
    type: constants.SET_CURRENT_SKU,
    payload: {
      skuInfo,
    },
  };
}

export function setSpuScore(score: string | null) {
  return {
    type: constants.SET_SPU_SCORE,
    payload: {
      score,
    },
  };
}

export function setDefaultAddress(address: AddressItemType | null) {
  return {
    type: constants.SET_DEFAULT_ADDRESS,
    payload: {
      address,
    },
  };
}

export function setFreightInfo(fee: FreightInfoType | null) {
  return {
    type: constants.SET_FREIGHT_INFO,
    payload: fee,
  };
}

export function setSkuPrice(info: SkuPriceType) {
  return {
    type: constants.SET_SKU_PRICE,
    payload: info,
  };
}

export function setBaseDetail(detail: ProductDetailType) {
  return {
    type: constants.SET_BASE_DETAIL,
    payload: detail,
  };
}

export function setSkuSelectorVisible(visible: boolean) {
  return {
    type: constants.SET_SKU_SELECTOR_VISIBLE,
    payload: visible,
  };
}

export function setSkuAction(action: number) {
  return {
    type: constants.SET_SKU_ACTION,
    payload: action,
  };
}

export function setDeepLink(deeplink: string) {
  return {
    type: constants.SET_DEEP_LINK,
    payload: deeplink,
  };
}

export function setSaleStockInfos(stocks: SaleStockInfoType | null) {
  return {
    type: constants.SET_SALE_STOCK_INFOS,
    payload: stocks,
  };
}

export function setInstallmentPlans(installments: InstallmentPlanItemType | null) {
  return {
    type: constants.SET_INSTALLMENT_PLANS,
    payload: installments,
  };
}

export function setPageLoading(loading: boolean) {
  return {
    type: constants.SET_PAGE_LOADING,
    payload: loading,
  };
}

export function setIsInitReport(value: boolean) {
  return {
    type: constants.SET_IS_INIT_REPORT,
    payload: value,
  };
}

export function resetState() {
  return {
    type: constants.RESET_STATE,
  };
}

export function setOpenAppLink(link: string) {
  return {
    type: constants.SET_OPEN_APP_LINK,
    payload: link,
  };
}
